var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7207 14.7817C14.0117 15.0728 14.4906 15.0728 14.7817 14.7817C15.0728 14.4906 15.0728 14.0117 14.7817 13.7207L8.56103 7.5L14.7817 1.27934C15.0728 0.988263 15.0728 0.50939 14.7817 0.21831C14.4906 -0.07277 14.0117 -0.07277 13.7207 0.21831L7.5 6.43897L1.27934 0.21831C0.988263 -0.07277 0.50939 -0.07277 0.21831 0.21831C-0.07277 0.50939 -0.07277 0.988263 0.21831 1.27934L6.43897 7.5L0.21831 13.7207C-0.07277 14.0117 -0.07277 14.4906 0.21831 14.7817C0.50939 15.0728 0.988263 15.0728 1.27934 14.7817L7.5 8.56103L13.7207 14.7817Z",
    fill: "#11304D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.c2bd391cf32ae347f21101a7a124e3a7.svg";
export { ForwardRef as ReactComponent };